// Header.js
import React from "react";
import wizheader from "../../assets/wizheader.png";
import "./Header.css";

const Header = () => {
  return (
    <div className="wizard-headerc">
      <div className="purple-circle"></div>
      <div className="purple-ellipse"></div>
      <div className="header-content">
        <div className="header-text">
          <h1>Race Wizard</h1>
          <p>
            Set up your race by choosing tokens, defining the duration, betting
            rules, and winner criteria—all in a few simple steps.
          </p>
        </div>
        <div className="header-image">
          <img src={wizheader} alt="Race Wizard" width={300} height={300} />
        </div>
      </div>
    </div>
  );
};

export default Header;
